enum TouchPosition {
  START_POSITION = 'START_POSITION',
  END_POSITION = 'END_POSITION',
}

export default TouchPosition;
